module.exports = __webpack_public_path__ + "static/media/avatar.a3131e28.png";